import * as Dinamic from "@ali/dinamic";
const {dataParser}  = Dinamic;


// 清空打点串字符特殊字符
export const checkLogString = (value)  => {
  const reg = /[&=\s]/g;
  if (reg.test(value)) {
    console.warn && console.warn(`打点业务串 ${value} 中不允许含有保留字符 &=`);
    return value.replace(reg, '');
  }
  return value;
};

export const getLogParamsString = (options) => {
  return Object.keys(options).map((item) => {
    let value = options[item];
    if (value === undefined) {
      value = '';
    }
    value = checkLogString(value.toString());
    return `${item}=${value}`;
  }).join('&');
};


export const getDXDotObject = (props) => {
  
  const {accessibilityText, onTap} = props;
  let params = "";
  let gokey = "";
  let type = "";
  let dotParams;
  // 打点属性配置
  if(onTap && onTap.options) {
    let data = onTap.options.data;

    if (data.traceInfo) {
      gokey  = data.traceInfo.name;
      if (/product$/.test(gokey)) {
        type = 'product';
      }else if (/supplier$/.test(gokey)) {
        type = 'supplier';
      } else if (/entrance$/.test(gokey)) {
        type = 'entrance';
      } else if (/nav$/.test(gokey)) {
        type = 'nav';
      }
      // 推荐标准是traceInfo.param, 但某些历史情况是traceInfo.activityTraceId
      dotParams = data.traceInfo.param || {};
      dotParams.floorName = data.traceInfo.name || "";
      // 当没有traceInfo.param时，尝试使用activityTraceId来兜底
      if(!data.traceInfo.param && data.traceInfo.activityTraceId) {
        dotParams.activityTraceId = data.traceInfo.activityTraceId;
      }

    }
  }
  let href = "";
  let eurl = '';
  if (onTap) {
    let pattern = onTap.pattern;
    const reg = /@data{([^}]*)}/g;
    const execValues = reg.exec(onTap.pattern);
    let p4ppattern = '@data{eurl}';
    if (execValues && execValues[1]){
      pattern = "@data{" + execValues[1] + '.action}';
      p4ppattern = "@data{" + execValues[1] + '.eurl}';
    } else {
      pattern = '@data{action}';
    }
    href = dataParser(pattern, onTap.options);
    eurl = dataParser(p4ppattern, onTap.options);
    if (!type && dotParams) {
      type = "entrance";
    }
  }
  
  if (dotParams) {
    params = getLogParamsString(Object.assign({ intelligent: 1 }, dotParams));
    if (type === 'nav') {
      params = getLogParamsString(Object.assign({ intelligent: 1 }, setNavDotParams(dotParams)));
    }
  }

  return {
    eurl,
    href,
    type,
    params
  }
}


// 个性化导航打点统一参数处理
export function setNavDotParams(params) {
  const reg = /[^\d_a-zA-Z\-%]/g;
  // navNames检查，不允许其它特殊字符，空格

  if (params.navNames) {
    if (typeof params.navNames === 'object') {
      params.navNames = params.navNames.map((v) => {
        return encodeURIComponent(v.toString()).replace(reg, '');
      });
      params.navNames = params.navNames.join('#');
    } else if (typeof params.navNames === 'string') {
      params.navNames = params.navNames.replace(',', '#');
    }
  }
  if (params.parentNavName) {
    params.parentNavName = encodeURIComponent(params.parentNavName).replace(reg, '');
  }
  return params;
}


export function checkPCP4PDot (dotObject) {
  // PC广告品 需要前端发起付费请求
  if (window.__p4pdot && dotObject.eurl && dotObject.href.indexOf("www.alibaba.com/") > -1 ) {
    console.log(dotObject,window.__p4pdot);
    window.__p4pdot(dotObject.eurl);
  }
}